module.exports = __webpack_public_path__ + "img/home.e1745b23.svg";